import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

function Registration() {
  let navigate = useNavigate();

  const initialValues = {
    fullname: "",
    username: "",
    country: "",
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    fullname: Yup.string()
      .matches(
        /^[a-zA-Z\s]*$/,
        "Full name can only contain letters and spaces."
      )
      .min(1)
      .max(50)
      .required("The full name is required!"),
    username: Yup.string()
      .matches(
        /^[a-zA-Z0-9._]*$/,
        "Only letters, numbers, dots, and underscores are allowed."
      )
      .test(
        "no-spaces",
        "Username cannot contain spaces.",
        (value) => !/\s/.test(value)
      )
      .min(3)
      .max(15)
      .required("The username is required!"),
    country: Yup.string().required("The country is required!"),
    email: Yup.string()
      .email("The email is invalid!")
      .required("The email is required!"),
    password: Yup.string().min(4).max(20).required("The password is required!"),
  });

  const [listOfCountries, setListOfCountries] = useState([]);

  useEffect(() => {
    axios
      .get("https://restcountries.com/v3.1/all?fields=name,flags")
      .then((response) => {
        setListOfCountries(response.data);

        const commonNames = response.data.map((country) => country.name.common);
        setListOfCountries(commonNames); // Saving the common names in state
      });
  }, []);

  const onSubmit = (data) => {
    axios.post("https://verbalvortex-server.onrender.com/auth", data).then((response) => {
      navigate(
        `/verifyEmail?email=${response.data.email}&username=${response.data.username}`
      );
    });
  };

  return (
    <div className="Registration">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form className="Registration__form">
          <h2>REGISTER NOW</h2>
          <ErrorMessage name="fullname" component="span" />
          <Field
            autocomplete="off"
            id="inputCreatePost"
            name="fullname"
            placeholder="Full name *"
            type="text"
            className="Registration__form__input"
          />

          <ErrorMessage name="username" component="span" />
          <Field
            autocomplete="off"
            id="inputCreatePost"
            name="username"
            placeholder="Username *"
            type="text"
            className="Registration__form__input"
          />

          <ErrorMessage name="country" component="span" />
          <Field
            as="select"
            name="country"
            className="Registration__form__input"
          >
            <option style={{ color: "white" }} value="">
              Country *
            </option>

            {listOfCountries.map((country, key) => (
              <option key={key} value={country}>
                {country}
              </option>
            ))}
          </Field>

          <ErrorMessage name="email" component="span" />
          <Field
            autocomplete="off"
            id="inputCreatePost"
            name="email"
            placeholder="Email address *"
            type="email"
            className="Registration__form__input"
          />

          <ErrorMessage name="password" component="span" />
          <Field
            autocomplete="off"
            id="inputCreatePost"
            name="password"
            placeholder="Password *"
            type="password"
            className="Registration__form__input"
          />

          <button type="submit">Sign up</button>

          <p>
            Have an account?{" "}
            <Link to="/" id="Login-link">
              Login here
            </Link>
          </p>
        </Form>
      </Formik>
    </div>
  );
}

export default Registration;
